import store from '@store';

// Tương đương `actions.getUserData()` của bản cũ (đọc sessionStorage 'iservice-user-data').
// Ở repo đích, hồ sơ người dùng nằm trong redux (account.profile) nên đọc thẳng từ store.
// KHÔNG có phụ thuộc ngược: store/ không import utils/ (đã kiểm tra) nên không vòng lặp import.
export const getUserData = () => store.getState()?.account?.profile;

export const getUserSettings = () => getUserData()?.settings;
